// extracted by mini-css-extract-plugin
export var addButton = "_ip-0";
export var border = "_ip-8";
export var check = "_ip-h";
export var danger = "_ip-6";
export var dropdownContainer = "_ip-1";
export var editModalBody = "_ip-j";
export var footerContainer = "_ip-i";
export var fullWidth = "_ip-a";
export var hide = "_ip-9";
export var icon = "_ip-3";
export var input = "_ip-7";
export var inputFlex = "_ip-b";
export var inputWrapper = "_ip-c";
export var manualFocus = "_ip-5";
export var optionButton = "_ip-4";
export var pillWrapper = "_ip-e";
export var pointer = "_ip-2";
export var showOverflow = "_ip-f";
export var tagsFlex = "_ip-d";
export var xButton = "_ip-g";